import { Component, ElementRef, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';

import { IGroupedByDateItem, ISportEvent, ITypeSegment } from '@frontend/oxygen/shared-utils';
import { Observable, Subscription, forkJoin, from, of as observableOf, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as _ from 'underscore';

import { EnvironmentConfig } from '../../../client-config/index';
import { ICoupon } from '../../../core/models/coupon.model';
import { CacheEventsService } from '../../../core/services/cacheEvents/cache-events.service';
import { CmsService } from '../../../core/services/cms/cms.service';
import { ISystemConfig } from '../../../core/services/cms/models';
import { ILeagueLink } from '../../../core/services/cms/models/league-links.model';
import { PubSubService } from '../../../core/services/communication/pubsub/pubsub.service';
import { DeviceService } from '../../../core/services/device/device.service';
import { DomToolsService } from '../../../core/services/domTools/dom.tools.service';
import { GtmService } from '../../../core/services/gtm/gtm.service';
import { RoutingHelperService } from '../../../core/services/routingHelper/routing-helper.service';
import { GamingService } from '../../../core/services/sport/gaming.service';
import { StorageService } from '../../../core/services/storage/storage.service';
import { TimeService } from '../../../core/services/time/time.service';
import { UserService } from '../../../core/services/user/user.service';
import { WindowRefService } from '../../../core/services/windowRef/window-ref.service';
import { OptaScoreboardLoaderService } from '../../../edp/services/optaScoreboard/opta-scoreboard-loader.service';
import { OptaScoreboardOverlayService } from '../../../edp/services/optaScoreboard/opta-scoreboard-overlay.service';
import { AbstractOutletComponent } from '../../../shared/components/abstractOutlet/abstract-outlet.component';
import { ILazyComponentOutput } from '../../../shared/components/lazy-component/lazy-component.model';
import { ICouponMarketMapping, ICouponMarketSelector, IDateCoupon } from '../../../shared/components/marketSelector/market-selector.model';
import { RendererService } from '../../../shared/services/renderer/renderer.service';
import { RoutingState } from '../../../shared/services/routingState/routing-state.service';
import { MarketSortService } from '../../services/marketSort/market-sort.service';
import { SportsConfigService } from '../../services/sportsConfig/sports-config.service';
import { COUPONS, DATED_COUPONS } from '../couponsList/coupons-list.constant';
import { ICouponSegment } from '../couponsList/coupons-list.model';
import { CouponsListService } from '../couponsList/coupons-list.service';
import { ICouponCheck, ICouponsConfig } from '../couponsListSportTab/coupons.model';
import {
    COUPONS_WIDGET,
    COUPON_NAMES_CONFIG,
    COUPON_NAMES_TYPE,
    COUPON_STAT_AVAILABLE_IDS,
    FOOTBALL_COUPONS,
    GA_COUPON_STATS_WIDGET,
    MAX_COUPON_WIDGETS,
    SHOWSTATSENABLEDAYSLIMIT,
} from './coupons-details.constant';
import { CouponsDetailsService } from './coupons-details.service';
import { IOnboardingOverlay } from './onboarding-coupon-stat-overlay.model';

interface ILeagueLinksMap {
    [obId: string]: { leagueId: string; leagueName: string };
}

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'coupons-details',
    templateUrl: './coupons-details.component.html',
    styleUrls: ['./coupons-details.component.scss'],
    providers: [CouponsDetailsService],
    standalone: false,
})
export class CouponsDetailsComponent extends AbstractOutletComponent implements OnInit, OnDestroy {
    couponsList: ICoupon[] = [];
    availableCoupons: ICoupon[] = [];
    availableDateCoupons: ICoupon[] = [];
    availableCouponsName: string[] = [];
    marketOptions: ICouponMarketSelector[] = [];
    marketOptionsTemp: ICouponMarketSelector[] = [];
    couponNamesConfig: typeof COUPON_NAMES_CONFIG;
    couponEvents: any[] = [];
    savedCouponEvents: any[] = [];
    applyingParams = true;
    applyingList = true;
    isEmptyEvents = false;
    isExpanded = [true, true, true];
    showCoupons = false;
    couponName: string = '';
    coupons: { name: string }[] = [];
    isBetFilterEnable: boolean = false;
    isEventsUnavailable: boolean = false;
    oddsHeader: string[] = [];
    couponId: string = '';
    marketFilter: string = '';
    couponFilter: string = '';
    footballService: GamingService | undefined;
    eventIdFromEDP: number;
    pageRenderTime: number = 1000;
    couponSegments: ICouponSegment[] = [];
    leagueLinksMap: ILeagueLinksMap = {};
    couponStatOpenedEvents: ISportEvent[] = [];
    isFootball: boolean = false;
    availableIds: string[] = [];
    maxCouponWidgets: number = MAX_COUPON_WIDGETS;
    includedLeagues: string[] = [];
    hideCoupons: boolean = true;
    public welcomeUrl: SafeResourceUrl;
    isShowDiv: boolean = false;
    homeBody: Element | undefined;
    isCSWOverlayEnabled: boolean = true;
    widgetType: any;
    isDisplayed: boolean = false;
    isLoading: boolean = true;
    selectedMarketSwitcher: string = '';
    twoUpMarkets = { '2up instant win': '2Up - Instant Win', '2up win early payout': '2Up&Win - Early Payout' };
    cmConfig: string[] = [];
    noEventsDropDown: boolean = false;
    dateFilter = ['Today', 'Tomorrow', 'Midweek', 'Weekend'];
    isGoalScore: boolean = false;
    isDataRetrieve: boolean = false;

    private detectListener: ReturnType<typeof setInterval>;
    private routeChangeSuccessHandler: Subscription;
    private couponsDetailsSubscription: Subscription;
    private couponsListSubscription: Subscription;
    private sportsConfigSubscription: Subscription;
    public onboardingCoupon: IOnboardingOverlay;
    public showOnboardingOverlay: boolean = false;
    private contentOverlayClassName: string = 'coupon-content-overlay';
    private readonly COUPON_NAMES_CONFIG = COUPON_NAMES_CONFIG;
    CMS_ENDPOINT: string;
    CWS_ONBOARDING: string = 'OnBoardingCSW';
    public readonly COUPON_STAT_AVAILABLE_IDS = COUPON_STAT_AVAILABLE_IDS;
    public readonly SHOWSTATSENABLEDAYSLIMIT = SHOWSTATSENABLEDAYSLIMIT;
    couponMarketMappings: ICouponMarketMapping[] = [];
    couponMarketMappingsSelected: ICouponMarketMapping[] | undefined;
    getCouponMarketSelectors: ICouponMarketSelector[] = [];
    private readonly environment = inject(EnvironmentConfig).configuration;
    dateCoupons: IDateCoupon[] = [];
    additionalMrkts = FOOTBALL_COUPONS.ADDITIONAL_MARKETS;
    exclusiveMrkts = FOOTBALL_COUPONS.EXCLUSIVE_MARKETS;
    get isDefaultCoupon(): boolean {
        return !this.couponsListService.containsValue(COUPONS.LEAGUE_COUPONS, this.couponId);
    }
    get isExcludedDate(): boolean {
        return this.couponsListService.isAdditionalcId(this.couponId, 'exclusive');
    }
    constructor(
        private activatedRoute: ActivatedRoute,
        private sportConfigService: SportsConfigService,
        private deviceService: DeviceService,
        private pubSubService: PubSubService,
        private marketSortService: MarketSortService,
        protected elementRef: ElementRef,
        private router: Router,
        protected domToolsService: DomToolsService,
        protected windowRefService: WindowRefService,
        public couponsDetailsService: CouponsDetailsService,
        private cacheEventsService: CacheEventsService,
        private routingState: RoutingState,
        private couponsListService: CouponsListService,
        private routingHelperService: RoutingHelperService,
        private cmsService: CmsService,
        private optaScoreboardLoaderService: OptaScoreboardLoaderService,
        private optaScoreboardOverlayService: OptaScoreboardOverlayService,
        private gtmService: GtmService,
        private userService: UserService,
        private storageService: StorageService,
        private rendererService: RendererService,
        private timeService: TimeService,
    ) {
        super() /* istanbul ignore next */;
        this.couponNamesConfig = this.COUPON_NAMES_CONFIG;
    }

    override ngOnInit() {
        this.CMS_ENDPOINT = this.environment.CMS_ENDPOINT!.split('/api')[0];
        this.detectListener = this.windowRefService.nativeWindow.setInterval(() => {
            if (this.eventIdFromEDP) {
                this.scrollToPreviousState();
            }
        }, 500);

        const couponName: string =
            this.activatedRoute.snapshot.paramMap.get('couponName') || this.activatedRoute?.snapshot?.parent?.paramMap.get('couponName') || '';
        this.couponId =
            this.activatedRoute.snapshot.paramMap.get('couponId')! || this.activatedRoute?.snapshot?.parent?.paramMap.get('couponId') || '';
        this.getCMSCouponMarketMapping();
        this.getMarketSelector();

        this.sportsConfigSubscription = this.sportConfigService.getSport('football').subscribe((sportService: GamingService) => {
            this.footballService = sportService;
            this.footballService.extendRequestConfig('coupons');
            this.pubSubService.subscribe('COUPON_MAPPING', 'COUPON_MAPPING', () => {
                this.setCouponsData(couponName);
            });
        });

        if (this.deviceService.isTablet || this.deviceService.isTabletLandscape) {
            this.setTabletTopTitleWidth();

            this.pubSubService.subscribe('CouponsDetailsCtrl', this.pubSubService.API.SHOW_HIDE_WIDGETS, () => this.setTabletTopTitleWidth());
        }

        this.routeChangeSuccessHandler = this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                const currentCouponId: string =
                    this.activatedRoute.snapshot.paramMap.get('couponId') ?? this.activatedRoute.snapshot.parent?.paramMap.get('couponId') ?? '';
                const currentCouponName: string =
                    this.activatedRoute.snapshot.paramMap.get('couponName') ?? this.activatedRoute.snapshot.parent?.paramMap.get('couponName') ?? '';
                const isRouteSegment: boolean = this.activatedRoute.snapshot.data['segment'] === 'couponsDetails';

                if (this.couponId !== currentCouponId && isRouteSegment) {
                    this.marketFilter = '';
                    this.couponId = currentCouponId;
                    this.applyingParams = true;
                    this.dateCoupons = [];
                    this.setCouponsData(currentCouponName);
                    this.isExpanded = [true, true, true];
                }
            }
        });

        // Block quick bet on coupon details page if configured in CMS
        this.couponsDetailsService.isQuickBetBlocked().subscribe((isQuickBetBlocked: boolean) => {
            if (!isQuickBetBlocked) {
                return;
            }

            this.pubSubService.subscribe('CouponsDetailsCtrl', this.pubSubService.API.BETSLIP_LOADED, () => {
                this.blockQuickBet();
            });
            this.blockQuickBet();
        });

        this.pubSubService.subscribe('CouponsDetailsCtrl', this.pubSubService.API.DELETE_EVENT_FROM_CACHE, (eventId: number) => {
            this.deleteEvent(eventId);
        });
        const sdmTag = document.createElement('div');
        sdmTag.id = 'sdm-scoreboards-modal';
        document.body.appendChild(sdmTag);
        this.getShowStatsIncludedLeagues();
    }

    private getShowStatsIncludedLeagues() {
        this.cmsService.getSystemConfig().subscribe((sysConfig: ISystemConfig) => {
            if (sysConfig && sysConfig.CouponStatsWidget && sysConfig.CouponStatsWidget) {
                const keys = Object.keys(sysConfig.CouponStatsWidget);
                this.includedLeagues = keys.filter((key) => sysConfig.CouponStatsWidget[key]);
            }
        });
    }

    closeFirstOpenedBoard() {
        const removeEvent = this.couponStatOpenedEvents.shift();
        if (!removeEvent) return;
        if (removeEvent.couponStatId) {
            this.availableIds.push(removeEvent.couponStatId);
        }
        removeEvent.isCouponScoreboardOpened = undefined;
        this.removeTagFromDom(removeEvent);
        this.sendGTMData(removeEvent);
    }

    removeTagFromDom(removeEvent: ISportEvent) {
        if (document.getElementById(removeEvent.couponStatId!)!) {
            document.getElementById(removeEvent.couponStatId!)!.remove();
            removeEvent.couponStatId = undefined;
            const spinner = document.getElementById('spin' + removeEvent.id);
            if (spinner) {
                spinner.remove();
            }
        }
    }

    closeCurrentBoard(currentEvent: ISportEvent) {
        if (currentEvent.couponStatId) {
            this.availableIds.push(currentEvent.couponStatId);
        }
        const currentEventIndex = this.couponStatOpenedEvents.findIndex((event: any) => event.id === currentEvent.id);
        this.couponStatOpenedEvents.splice(currentEventIndex, 1);
        currentEvent.isCouponScoreboardOpened = undefined;
        this.removeTagFromDom(currentEvent);
    }

    private initElements(): void {
        this.homeBody = this.deviceService.isWrapper!
            ? this.windowRefService.document.querySelector('body')!
            : this.windowRefService.document.querySelector('html, body')!;
    }

    sendGTMData(removeEvent: ISportEvent) {
        const gtmData = {
            event: 'trackEvent',
            eventAction: 'click',
            eventCategory: 'coupon stats widget',
            eventLabel: 'hide stats',
            categoryID: removeEvent.categoryId,
            typeID: removeEvent.typeId,
            eventID: removeEvent.id,
        };
        this.gtmService.push(gtmData.event, gtmData);
    }

    public setGtmData(data: any, label?: string, buttonText?: string): void {
        const gtmData = {
            'event': data.event,
            'component.CategoryEvent': data.categoryEvent,
            'component.LabelEvent': label ? label : data.labelEvent,
            'component.ActionEvent': data.actionEvent,
            'component.PositionEvent': data.positionEvent,
            'component.LocationEvent': data.locationEvent,
            'component.EventDetails': buttonText ? buttonText : data.eventDetails,
            'component.URLClicked': data.URLClicked,
        };
        this.gtmService.push(gtmData.event, gtmData);
    }

    onExpand(currentEvent: ISportEvent) {
        currentEvent.isCouponScoreboardOpened = !currentEvent.isCouponScoreboardOpened;
        if (currentEvent.isCouponScoreboardOpened) {
            if (
                this.isCSWOverlayEnabled &&
                this.userService.username &&
                this.deviceService.requestPlatform === 'mobile' &&
                this.storageService.get(this.CWS_ONBOARDING) &&
                this.userService.username === this.storageService.get(this.CWS_ONBOARDING).user &&
                this.storageService.get(this.CWS_ONBOARDING).widget === 'couponAndMarketSwitcherWidget'
            ) {
                this.getOnboardingOverlayCMS('coupon-stats-widget');
            }
            this.couponStatOpenedEvents.push(currentEvent);
            if (this.couponStatOpenedEvents.length > this.maxCouponWidgets) {
                this.closeFirstOpenedBoard();
            }
            const newId: any = this.availableIds.shift();
            currentEvent.couponStatId = newId;
        } else {
            this.closeCurrentBoard(currentEvent);
        }
    }

    override ngOnDestroy() {
        this.hideCoupons = true;
        this.marketFilter = '';
        this.applyingParams = true;
        this.cacheEventsService.clearByName('coupons');
        this.windowRefService.nativeWindow.clearInterval(this.detectListener);
        // unSubscribe LS Updates via liveServe PUSH updates (iFrame)!
        this.footballService!.unSubscribeCouponsForUpdates('football-coupons');
        this.pubSubService.unsubscribe('CouponsDetailsCtrl');
        this.pubSubService.unsubscribe('COUPON_MARKET_SELECTOR_1');
        this.pubSubService.unsubscribe('COUPON_MAPPING');
        this.routeChangeSuccessHandler && this.routeChangeSuccessHandler.unsubscribe();
        this.couponsDetailsSubscription && this.couponsDetailsSubscription.unsubscribe();
        this.couponsListSubscription && this.couponsListSubscription.unsubscribe();
        this.sportsConfigSubscription && this.sportsConfigSubscription.unsubscribe();
        this.blockQuickBet(false);
        this.optaScoreboardOverlayService.destroyOverlay();
        if (this.homeBody) {
            this.rendererService.renderer.removeClass(this.homeBody, this.contentOverlayClassName);
        }
    }

    trackById(index: number, element: ISportEvent): string {
        return element.id ? `${index}${element.id}` : index.toString();
    }

    trackByTypeId(index: number, element: ITypeSegment): string {
        return `${index}${element.typeId}${element.deactivated}`;
    }

    changeAccordionState(i: number, value: boolean): void {
        this.isExpanded[i] = value;
    }

    isDisplay() {
        this.isDisplayed = true;
    }
    /**
     * filterEvents()
     * @param {string} marketFilter
     */
    filterEvents(marketFilter: string): void {
        this.isGoalScore = marketFilter === 'Goalscorer Coupon';
        const isAdditionalMrkt = this.couponsListService.isAdditionalMrkt(marketFilter);
        const isDated = this.couponsListService.containsValue('DateCoupons', this.couponId);
        const isAdditionalcId = this.couponsListService.isAdditionalcId(this.couponId, 'both');
        const chkCoupon = this.couponsListService.getCouponFilterName(this.couponFilter);
        if (isAdditionalMrkt && this.marketFilter && this.marketFilter != marketFilter) {
            this.filterCouponsFromMrkt(marketFilter, chkCoupon);
            return;
        }
        if (!isAdditionalMrkt && isAdditionalcId && !this.marketFilter) {
            const cname = COUPON_NAMES_TYPE.exclusive.includes(this.couponFilter.toLowerCase()) ? this.couponFilter : this.dateCoupons[0]?.name;
            this.filterCoupons(cname, marketFilter);
        }
        if (!isAdditionalMrkt && !isDated && isAdditionalcId && this.marketFilter) {
            const isSelectedAddMrkt: boolean = this.couponsListService.isAdditionalMrkt(this.couponFilter);
            const isFilterAvailable: boolean = this.dateCoupons.some((cp) => cp.name === chkCoupon);
            const noDateDrpCheck: string = this.dateCoupons?.length ? this.dateCoupons[0]?.name : DATED_COUPONS.TODAY;
            const setCoupon: string = isFilterAvailable ? chkCoupon : isSelectedAddMrkt ? noDateDrpCheck : this.couponFilter;
            this.filterCoupons(setCoupon, marketFilter);
        }
        this.selectedMarketSwitcher = '';
        this.hideCoupons = false;
        this.marketFilter = marketFilter;

        this.selectedMarketSwitcher = (this.twoUpMarkets as any)[marketFilter];
        !this.isExcludedDate && this.marketSortService.setMarketFilterForMultipleSections(this.savedCouponEvents, marketFilter);
        this.isEventsUnavailable = this.getEventsIsUnavailable;
        this.oddsHeader = this.couponsDetailsService.setOddsHeader(this.marketOptions, marketFilter);
        // filter events and keep reference to the array
        this.couponEvents.length = 0;
        this.couponEvents.push(...this.filteredEvents());
        this.removeAllWidgetsFromDom();
    }
    filterCouponsFromMrkt(marketFilter: string, previousCoupon: string) {
        if (!Array.isArray(this.couponsList)) return;

        const marketMap: Record<string, string> = {
            'Score Goal in Both Halves': 'Goal in Both Halves',
            'Correct Scores': 'Correct Score',
        };

        marketFilter = marketMap[marketFilter] || marketFilter;
        const coupon = this.checkCouponMrkt(marketFilter, previousCoupon);

        if (coupon && COUPON_NAMES_TYPE.uniqids.includes(marketFilter.toLowerCase())) {
            coupon.name = marketFilter === 'Correct Score' ? 'Correct Scores' : marketFilter;
        }
        this.redirectCoupon(coupon);
    }
    checkCouponMrkt(marketFilter: string, previousCoupon: string): ICoupon {
        const combineCname = this.getCombineName(marketFilter, previousCoupon);
        const chkMarket = combineCname ? combineCname.toLowerCase() : marketFilter.toLowerCase();
        return (
            this.couponsList.find((coup) => coup.name?.toLowerCase() === chkMarket || coup.name?.toLowerCase().includes(chkMarket)) || ({} as ICoupon)
        );
    }
    getCombineName(marketFilter: string, previousCoupon: string) {
        const isDated =
            !COUPON_NAMES_TYPE.exclusive.includes(marketFilter.toLowerCase()) &&
            previousCoupon !== DATED_COUPONS.TODAY &&
            Object.values(DATED_COUPONS).includes(previousCoupon);
        if (!isDated) {
            return marketFilter;
        }
        return marketFilter.toLowerCase() === 'both teams to score in both halves'
            ? `${previousCoupon} btts in both halves`
            : `${previousCoupon} ${marketFilter}`;
    }
    /**
     * To filter the coupons
     * @param selectedCoupon {string[]}
     */
    filterCoupons(selectedCoupon: string | string[], source?: string): void {
        let sCoupon = selectedCoupon;
        this.noEventsDropDown = false;
        if (Array.isArray(selectedCoupon)) {
            sCoupon = selectedCoupon[0];
        }
        this.couponsDetailsService.pushToGTM(sCoupon as string);
        this.selectedMarketSwitcher = '';
        this.couponFilter = sCoupon as string;
        let coupon: ICoupon | ICouponCheck | undefined = undefined;
        const isMse: boolean =
            this.couponsListService.containsValue(COUPONS.CORRECT_SCORE as keyof ICouponsConfig, this.couponId) ||
            this.couponsListService.containsValue(COUPONS.BBTS as keyof ICouponsConfig, this.couponId) ||
            this.couponsListService.containsValue(COUPONS.DOUBLE_CHANCE as keyof ICouponsConfig, this.couponId);
        const redirectCoupon = isMse && this.couponsListService.checkCurrentCoupon(this.couponId, sCoupon as string);
        if (redirectCoupon && !source) {
            coupon = redirectCoupon;
            coupon.name =
                this.activatedRoute.snapshot.paramMap.get('couponName') || this.activatedRoute?.snapshot?.parent?.paramMap.get('couponName') || '';
        } else {
            //@ts-ignore
            this.couponSegments?.every((segment: ICouponSegment) => {
                if (!coupon) {
                    coupon =
                        segment?.coupons?.find(
                            (coup) =>
                                coup.name === this.couponFilter ||
                                (coup.name.includes(this.couponFilter) &&
                                    this.couponsListService.containsValue(COUPONS.DATE_COUPONS as keyof ICouponsConfig, coup.id)),
                        ) || ({} as ICoupon | ICouponCheck);
                    return !coupon;
                }
            });
        }
        this.redirectCoupon(coupon);
    }
    redirectCoupon(coupon: ICoupon | ICouponCheck | undefined) {
        if (!coupon) {
            this.isEmptyEvents = true;
            this.couponEvents = [];
            this.savedCouponEvents = [];
            this.noEventsDropDown = true;
            return;
        }
        const couponName = this.routingHelperService.encodeUrlPart(coupon?.name);
        this.router.navigate([`en/sports/coupons/football/${couponName}/${coupon?.id}`]);
    }

    /**
     * showCouponsList()
     */
    showCouponsList(): void {
        this.showCoupons = !this.showCoupons;
        this.scrollToTop();
    }

    /**
     * goToPage()
     * @param {string} path
     * @returns {void|boolean}
     */
    goToPage(path: string): Promise<boolean> | boolean {
        return path ? this.router.navigateByUrl(path) : false;
    }

    filteredEvents(): ITypeSegment[] {
        return this.savedCouponEvents.filter((event: any) => !event.deactivated);
    }

    handleMatchesMarketSelectorEvent(event: ILazyComponentOutput): void {
        if (event.output === 'filterChange') {
            this.filterEvents(event.value);
        }
    }

    openLeagueTable(events: ITypeSegment): void {
        this.optaScoreboardOverlayService.setOverlayData({
            overlayKey: 'leagueTable',
            data: this.leagueLinksMap[events.typeId],
        });
        this.sendGTM(events.events[0]);
        this.optaScoreboardOverlayService.showOverlay();
    }

    protected getStickyElementsHeight(): number {
        const couponsContainer = this.windowRefService.document.querySelector('.coupons-container-js');
        return !couponsContainer ? 0 : this.domToolsService.getOffset(couponsContainer)!.top;
    }

    private sendGTM(event: ISportEvent): void {
        this.pubSubService.publish(this.pubSubService.API.PUSH_TO_GTM, [
            'trackEvent',
            {
                eventCategory: 'in-line stats',
                eventAction: 'league table',
                eventLabel: event.typeName,
                categoryID: event.categoryId,
                typeID: `${event.typeId}`,
            },
        ]);
    }

    private updatePreviousStateInfo(): void {
        const previousSegment = this.routingState.getPreviousSegment();
        if (previousSegment !== 'eventMain') {
            return;
        }
        const regexpResult = /\/([0-9]*)\//.exec(this.routingState.getPreviousUrl()),
            eventIdFromEDP = regexpResult && +regexpResult[1];
        if (!eventIdFromEDP) {
            return;
        }
        const allEvents = (this.couponEvents as { events: any[] }[])
            .map((coupon) => coupon.events)
            .reduce((firstArray, secondArray) => firstArray.concat(secondArray), []);
        const eventIndex = allEvents.findIndex((event: any) => event.id === eventIdFromEDP);
        if (eventIndex === -1) {
            return;
        }
        const typeID = allEvents[eventIndex].typeId;
        const typeIndex = (this.couponEvents as { typeId: any }[]).findIndex((type) => type.typeId === typeID);
        this.isExpanded[typeIndex] = true;
        this.eventIdFromEDP = eventIdFromEDP;
    }

    /**
     * If redirecting back from coupons EDP, scroll to previous position on coupons page
     */
    private scrollToPreviousState(): void {
        const document: HTMLDocument = this.windowRefService.document,
            eventElement = document.querySelector(`.coupon-event-${this.eventIdFromEDP}`);
        // eventElement = document.querySelector(`#acc-${this.typeID}`);
        if (!eventElement) {
            return;
        }
        const eventElementOffset = this.domToolsService.getOffset(eventElement)!.top;
        setTimeout(() => {
            this.windowRefService.nativeWindow.scroll(0, eventElementOffset - this.getStickyElementsHeight());
            this.eventIdFromEDP = 0;
        });
    }

    private setCouponsData(couponName: string): void {
        const couponTitle = this.getCouponName(couponName);
        this.selectedMarketSwitcher = '';
        this.marketOptions = [];
        this.couponsDetailsService.isGoalscorerCoupon = couponTitle.toLowerCase() === this.couponNamesConfig.goalscorerCouponName.toLowerCase();
        this.footballService!.unSubscribeCouponsForUpdates('football-coupons');
        this.couponsDetailsService.index = -1;
        this.getCouponsData(couponTitle);
        this.hideSpinner();
    }

    /**
     * eventsIsUnavailable()
     * @returns {boolean}
     */
    private get getEventsIsUnavailable(): boolean {
        if (this.isEmptyEvents) {
            return true;
        }

        return this.couponsDetailsService.isCustomCoupon
            ? false
            : !_.some(this.couponEvents, (couponEvent: ITypeSegment) => {
                  return _.some(couponEvent.groupedByDate, (group: IGroupedByDateItem) => {
                      return group.deactivated === false || group.deactivated === undefined;
                  });
              });
    }
    private set getEventsIsUnavailable(value: boolean) {}

    /**
     * getCouponsListData()
     */
    private getCouponsListData(): void {
        this.couponsListSubscription = from(this.footballService!.coupons())
            .pipe(
                switchMap((data: ICoupon[]) => {
                    this.applyingList = false;
                    this.couponsList = data;

                    this.setCouponType(true);

                    if (this.couponsList && this.couponsList.length) {
                        this.couponsListService.getCouponSegment().subscribe((segments: ICouponSegment[]) => {
                            this.couponSegments = this.couponsListService.groupCouponBySegment(this.couponsList as any, segments);
                            this.groupCoupons();
                        });
                    }
                    const currentCoupon = this.couponsList.find((coupon: ICoupon) => coupon.id === this.couponId);
                    if (!currentCoupon) {
                        this.noEventsDropDown = true;
                        return observableOf(false);
                    }
                    this.couponName = this.getCouponName(currentCoupon.name);
                    return this.couponsDetailsService.isBetFilterEnable(currentCoupon);
                }),
            )
            .subscribe(
                (isEnable: boolean) => {
                    this.isBetFilterEnable = isEnable;
                },
                (error) => {
                    this.applyingList = false;
                    this.isBetFilterEnable = false;
                    this.couponsList = [];
                    this.coupons = [];
                    console.warn('Error:', error);
                    this.showError();
                },
            );
    }

    private groupCoupons(): void {
        if (this.couponSegments && this.couponSegments.length) {
            this.coupons = [];
            this.couponSegments.forEach((couponSegment) => {
                if (couponSegment.coupons?.length) {
                    couponSegment.coupons.forEach((coupon) => {
                        if (this.couponsListService.containsValue('leagueCoupons', coupon.id)) {
                            this.coupons.push({ name: coupon.name });
                        }
                    });
                }
            });
        }
    }
    /**
     * getCouponsData()
     * @param {string} couponName
     */
    private getCouponsData(couponName: string): void {
        this.savedCouponEvents = [];
        this.couponMarketMappingsSelected = this.couponMarketMappings.filter((x: any) => x.couponId === this.couponId);
        this.couponsDetailsService
            .getCouponEvents(this.couponId, couponName, this.footballService!, !!this.couponMarketMappingsSelected.length)
            .subscribe(
                ({ coupons, options }: { coupons: ISportEvent[]; options: ICouponMarketSelector[] }) => {
                    this.loadCouponEvents(coupons, options, true);
                },
                () => this.showError(),
            );

        this.pubSubService.subscribe('COUPON_MARKET_SELECTOR_1', 'COUPON_MARKET_SELECTOR', (flag: boolean) => {
            if (this.couponMarketMappingsSelected && this.couponMarketMappingsSelected?.length) {
                this.oddsHeader = [];
                const headerDetails = this.couponsDetailsService.marketSelectorArray?.find(
                    (x) => x.templateMarketName === this.couponMarketMappingsSelected?.[0].marketName,
                );
                if (headerDetails) {
                    // @ts-ignore
                    this.oddsHeader = this.couponsDetailsService.marketSelectorArray?.find(
                        (x) => x.templateMarketName === this.couponMarketMappingsSelected?.[0]?.marketName,
                    )?.header;
                }
                this.selectedMarketSwitcher = (this.twoUpMarkets as any)[couponName];
            }
        });
    }

    /**
     * Load Coupons Events
     * @param {ISportEvent[]} coupons
     * @param {ICouponMarketSelector[]} options
     */
    private loadCouponEvents(coupons: ISportEvent[], options: ICouponMarketSelector[], flag: boolean): void {
        // if OB events present but coupon is not configured then will show no events found.
        let curCoupon;
        this.marketOptionsTemp = options?.length > 0 ? options : this.exclusiveMrkts;
        if (Array.isArray(this.couponsList)) {
            this.setCouponType(false);
            curCoupon = this.dateCoupons.filter((item) => item.id === this.couponId);
            if (!curCoupon.length && this.dateCoupons.length) coupons = [];
        }
        const savedCouponEvents = this.couponsDetailsService.groupCouponEvents(coupons, this.footballService!);
        this.savedCouponEvents.push(...savedCouponEvents);
        this.couponEvents = this.savedCouponEvents.slice();
        this.isEmptyEvents = _.isEmpty(this.couponEvents);
        this.isEventsUnavailable = this.getEventsIsUnavailable;
        this.applyingParams = false;
        // const store = this.storageService.get('prevCouponMarket') || null;
        if (flag) {
            if (!this.isEmptyEvents) {
                this.footballService!.subscribeCouponsForUpdates(coupons, 'football-coupons');
                this.hideCoupons = this.marketOptions && this.marketOptions.length > 0;
            }
            if (!this.applyingParams && this.hideCoupons && !this.couponsDetailsService.isCustomCoupon && !this.isEventsUnavailable) {
                const CWS_ONBOARDING = this.storageService.get(this.CWS_ONBOARDING);
                const username = CWS_ONBOARDING ? CWS_ONBOARDING.user : '';
                const widget = CWS_ONBOARDING ? CWS_ONBOARDING.widget : '';
                const status =
                    this.userService.username === username && (widget === 'couponAndMarketSwitcherWidget' || widget === 'coupon-stats-widget');
                if (this.isCSWOverlayEnabled && this.userService.username && this.deviceService.requestPlatform === 'mobile' && !status) {
                    this.getOnboardingOverlayCMS('couponAndMarketSwitcherWidget');
                }
            }
            this.checkIsShowStatsEnabled();
            this.updatePreviousStateInfo();
            this.postLoadCalls();
        }
        this.couponEvents = this.couponMarketMappingsSelected?.length ? this.isCMSCouponsMappingEvents() : this.couponEvents;
    }

    /**
     * @returns any
     */
    isCMSCouponsMappingEvents(): any {
        let couponsFilterDup = JSON.parse(JSON.stringify(this.couponEvents));
        couponsFilterDup = couponsFilterDup.filter((couponEvent: any) => {
            couponEvent.events = couponEvent.events.filter((sportEvent: any) => {
                const selectedMarkets = [] as any;
                sportEvent.markets.forEach((market: any) => {
                    if (this.couponMarketMappingsSelected?.[0].marketName === market.templateMarketName) {
                        selectedMarkets.push(market);
                    }
                });
                sportEvent.markets = selectedMarkets;
                return sportEvent.markets.length ? true : false;
            });
            return couponEvent.events.length ? true : false;
        });
        return couponsFilterDup;
    }

    private checkIsShowStatsEnabled() {
        this.availableIds = _.clone(this.COUPON_STAT_AVAILABLE_IDS);
        this.couponStatOpenedEvents = [];
        // @ts-ignore
        if (this.footballService.isFootball) {
            this.isFootball = true;
            (this.couponEvents as any).forEach((e: any) => {
                if (this.includedLeagues?.includes(e.typeId.toString())) {
                    e.events.forEach((event: ISportEvent | any) => {
                        if (this.getdaysToEventStart(event) <= this.SHOWSTATSENABLEDAYSLIMIT) {
                            event.isShowStatsEnabled = true;
                        }
                    });
                }
            });
        }
    }

    removeAllWidgetsFromDom() {
        this.couponStatOpenedEvents.forEach((event: any) => {
            if (event.couponStatId) {
                this.availableIds.push(event.couponStatId);
            }
            event.isCouponScoreboardOpened = undefined;
            this.removeTagFromDom(event);
        });
        this.couponStatOpenedEvents = [];
    }

    private getdaysToEventStart(e: ISportEvent): number {
        return Math.ceil(-1 * this.timeService.daysDifference(e.startTime));
    }

    private initCouponLeagueLinks(couponId: string): Observable<ILeagueLink[]> {
        return this.cmsService.getSystemConfig().pipe(
            map((config: ISystemConfig): boolean => config && config.StatisticsLinks && config.StatisticsLinks.leagues),
            switchMap(
                (enabled: boolean): Observable<[ILeagueLink[], HTMLElement]> =>
                    enabled
                        ? forkJoin(this.cmsService.getCouponLeagueLinks(couponId), this.initScoreboardOverlay())
                        : throwError('Coupon League Links are disabled in CMS'),
            ),
            switchMap(([links, scoreboardOverlay]: [ILeagueLink[], HTMLElement]) => {
                switch (true) {
                    // @ts-ignore
                    case !links:
                    // @ts-ignore
                    case !links.length:
                        return throwError(`Coupon League Links are not available in CMS for the '${couponId}' couponId`);
                    // @ts-ignore
                    case !scoreboardOverlay:
                        return throwError(`Could not initialize Scoreboard Overlay`);
                    default:
                        return observableOf(links);
                }
            }),
            catchError((error) => {
                console.warn(error);
                return observableOf([]);
            }),
        );
    }

    private buildLeagueLinksMap(leagueLinks: ILeagueLink[]): ILeagueLinksMap {
        return leagueLinks.reduce(
            (linksMap, link) => Object.assign(linksMap, { [link.obLeagueId]: { leagueId: link.dhLeagueId, leagueName: link.linkName } }),
            {},
        );
    }

    private initScoreboardOverlay(): Observable<HTMLElement> {
        return this.optaScoreboardLoaderService.loadBundle().pipe(map(() => this.optaScoreboardOverlayService.initOverlay()));
    }

    private scrollToTop(): void {
        const couponsListElem = this.elementRef.nativeElement.querySelector('.coupons-list');
        if (this.showCoupons && couponsListElem) {
            this.windowRefService.document.body.scrollTop = 0; // For Safari
            this.windowRefService.document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            couponsListElem.scrollTop = 0; // Element scrollTop
        }
    }

    /**
     * setTabletTopTitleWidth()
     */
    private setTabletTopTitleWidth(): void {
        const couponsTopTitle = this.elementRef.nativeElement.querySelector('.coupons-top-title');
        if (!couponsTopTitle) {
            return;
        }

        const pageContent = this.windowRefService.document.getElementById('content');

        const elmWidth = this.domToolsService.getWidth(pageContent!);

        this.domToolsService.css(couponsTopTitle, 'width', `${elmWidth}px`);
        this.domToolsService.css(couponsTopTitle, 'transition', 'initial');
    }

    /**
     * deleteEvent()
     * @param {number} eventId
     */
    private deleteEvent(eventId: number): void {
        this.savedCouponEvents.forEach((section: ITypeSegment, i: number) => {
            if (section) {
                this.deleteIndex(section, eventId, i);
                section.groupedByDate.forEach((groupedSection: IGroupedByDateItem, j: number) => {
                    this.deleteIndex(groupedSection, eventId, j);
                });
            }
        });
    }

    private deleteIndex(section: ITypeSegment | IGroupedByDateItem, eventId: number, index: number): void {
        const eventIndex = section.events.findIndex((event: ISportEvent) => Number(event.id) === Number(eventId));
        if (eventIndex !== -1) {
            section.events.splice(eventIndex, 1);
            if (!section.events.length) {
                section.events.splice(index, 1);
            }
        }
    }

    /**
     * getCouponName()
     * @param {string} couponName
     * @returns {string}
     */
    private getCouponName(couponName: string): string {
        const couponTitle = couponName?.replace(/-/g, ' ');
        const overUnderCoupon =
            this.couponNamesConfig.overUnderOriginalName.toLowerCase() === couponTitle.toLowerCase() && this.couponNamesConfig.overUnderOriginalName;
        const ukCoupon = this.couponNamesConfig.ukCoupon.toLowerCase() === couponTitle.toLowerCase() && this.couponNamesConfig.ukCoupon;
        const cs = this.couponNamesConfig.correctScore.toLowerCase() === couponTitle.toLowerCase() && this.couponNamesConfig.correctScore + 's';

        return cs || overUnderCoupon || ukCoupon || couponTitle;
    }

    private blockQuickBet(block: boolean = true): void {
        this.pubSubService.publish(this.pubSubService.API.BLOCK_QUICK_BET, block);
    }

    private getOnboardingOverlayCMS(requestParam: any): void {
        this.cmsService.getOnboardingOverlay(requestParam).subscribe(
            (onboardingOverlay: IOnboardingOverlay) => {
                this.isCSWOverlayEnabled = onboardingOverlay.isEnable;
                if (onboardingOverlay.isEnable) {
                    this.initElements();
                    this.rendererService.renderer.addClass(this.homeBody, this.contentOverlayClassName);
                    this.storageService.set(this.CWS_ONBOARDING, { user: this.userService.username, displayed: true, widget: requestParam });
                    if (requestParam === 'couponAndMarketSwitcherWidget') {
                        this.setGtmData(COUPONS_WIDGET);
                        this.widgetType = COUPONS_WIDGET;
                    } else if (requestParam === 'coupon-stats-widget') {
                        this.isShowDiv = false;
                        this.setGtmData(GA_COUPON_STATS_WIDGET);
                        this.widgetType = GA_COUPON_STATS_WIDGET;
                    }
                }
                this.showOnboardingOverlay = true;
                this.welcomeUrl = `${this.CMS_ENDPOINT}${onboardingOverlay.imageUrl} || ''`;
                this.onboardingCoupon = onboardingOverlay;
                this.isLoading = false;
            },
            (error) => {
                console.warn(error);
            },
        );
    }

    imageclose(location: string) {
        location === 'close'
            ? this.setGtmData(this.widgetType, location)
            : this.setGtmData(this.widgetType, `${this.onboardingCoupon.buttonText}`, `${this.onboardingCoupon.buttonText} cta`);
        this.isShowDiv = true;
        this.showOnboardingOverlay = false;
    }

    private getCMSCouponMarketMapping(): void {
        this.couponsDetailsService.getCMSCouponMapping().subscribe((CouponMarketMapping: ICouponMarketMapping[]) => {
            this.couponMarketMappings = CouponMarketMapping;
            this.pubSubService.publish('COUPON_MAPPING', this.couponMarketMappings);
        });
    }

    private getMarketSelector(): void {
        this.couponsDetailsService.getMarketSelector().subscribe((data) => {
            this.getCouponMarketSelectors = data;
            this.couponsDetailsService.marketSelectorArray = data;
        });
    }

    private postLoadCalls(): void {
        this.getCouponsListData();
        this.initCouponLeagueLinks(this.couponId).subscribe((data) => {
            this.leagueLinksMap = data?.length ? this.buildLeagueLinksMap(data) : (0 as unknown as ILeagueLinksMap);
        });
        if (!this.couponsDetailsService.isCustomCoupon) {
            this.isDataRetrieve = false;
            this.fetchPendingEvents();
        } else {
            this.isDataRetrieve = true;
        }
    }

    private fetchPendingEvents(): void {
        const savedCouponEvents = this.couponsDetailsService.groupCouponEvents(this.couponsDetailsService.initialCoupons, this.footballService!);
        const couponEvents = this.couponsDetailsService.loadCouponEvents(this.couponsDetailsService.initialCoupons);
        if (couponEvents.length > 0 && this.couponsDetailsService.isCMSCoupons) {
            this.couponsDetailsService.getCMSCouponMarketSelectorForMapping(this.couponId, couponEvents).subscribe(({ coupons, options }) => {
                coupons.length > 0 && this.loadCouponEvents(coupons, [], false);
                if (savedCouponEvents.length > this.couponsDetailsService.index + 1) {
                    this.fetchPendingEvents();
                }
                this.isDataRetrieve = true;
            });
        } else if (couponEvents.length > 0 && !this.couponsDetailsService.isCMSCoupons) {
            this.couponsDetailsService.getEventById(couponEvents).subscribe(({ coupons, options }) => {
                coupons.length > 0 && this.loadCouponEvents(coupons, options, false);
                if (
                    options.filter(
                        (item: ICouponMarketSelector) =>
                            item.templateMarketName === this.storageService.get('storeSelectedOption')?.football?.selectedOption,
                    ).length
                ) {
                    const mergedMarkets: ICouponMarketSelector[] = [
                        ...new Map([...options, ...this.marketOptions].map((market) => [market.templateMarketName, market])).values(),
                    ];
                    const initialObj: ICouponMarketSelector = mergedMarkets.shift()!;
                    this.marketOptions = this.sortMarketNames(mergedMarkets);
                    this.marketOptions.unshift(initialObj);
                }
                if (savedCouponEvents.length > this.couponsDetailsService.index + 1) {
                    this.fetchPendingEvents();
                }
                this.isDataRetrieve = true;
            });
        } else {
            this.isDataRetrieve = true;
        }
    }
    /**
     * To get sorted coupon markets selectors
     * @returns - ICouponMarketSelector[]
     */
    private sortMarketNames(uniq: ICouponMarketSelector[]): ICouponMarketSelector[] {
        const orderMap = new Map(FOOTBALL_COUPONS.MARKETS_NAME_ORDER.map((name: string, index: number) => [name.toLowerCase(), index]));
        uniq?.sort((a: ICouponMarketSelector, b: ICouponMarketSelector) => {
            const indexA: number = orderMap.get(a?.title?.toLowerCase()) ?? Number.MAX_SAFE_INTEGER;
            const indexB: number = orderMap.get(b?.title?.toLowerCase()) ?? Number.MAX_SAFE_INTEGER;
            return indexA - indexB;
        });
        return uniq;
    }

    setCouponType(bool?: boolean) {
        this.availableCouponsName = [];
        this.availableCoupons = [];
        this.availableDateCoupons = [];
        const currentCouponName: string = this.getCouponName(
            this.activatedRoute.snapshot.paramMap.get('couponName') || this.activatedRoute?.snapshot?.parent?.paramMap?.get('couponName') || '',
        );
        const isDated = this.couponsListService.containsValue('DateCoupons', this.couponId);
        const isUniqIds = this.couponsListService.isAdditionalcId(this.couponId, 'uniqids');
        const datedCoupons = (this.couponsListService.getCouponsConfigValue(COUPONS.DATE_COUPONS as keyof ICouponsConfig)() as string).split(',');
        const currentMarketsIds = this.couponsListService.getConfigList(this.couponId);
        this.couponsList.forEach((coupon: ICoupon) => {
            this.availableCouponsName.push(coupon.name);
            if (coupon.id === this.couponId) {
                this.couponFilter = coupon.name;
            }
            if (datedCoupons?.includes(coupon.id)) {
                this.availableDateCoupons.push(coupon);
            }
            if ((isUniqIds && currentMarketsIds?.includes(coupon.id)) || (isDated && datedCoupons?.includes(coupon.id))) {
                this.availableCoupons.push(coupon);
            }
        });
        this.dateCoupons = this.couponsListService.sortDatedCoupons(this.getDatedCoupons(currentCouponName));
        if (bool) this.setMarketOptions();
    }
    getDatedCoupons(cName: string): IDateCoupon[] {
        const isDated = this.couponsListService.containsValue('DateCoupons', this.couponId);
        return this.availableCoupons.map(({ name, id }) => {
            if (name.toLowerCase() === cName.toLowerCase() && !isDated) {
                name = DATED_COUPONS.TODAY;
            } else {
                name = this.couponsListService.getCouponFilterName(name);
            }
            return {
                name: name,
                templateMarketName: name.toLowerCase(),
                id,
            };
        });
    }
    setMarketOptions() {
        const isAdditionalcId = this.couponsListService.isAdditionalcId(this.couponId, 'both');
        const couponName: string =
            (this.activatedRoute.snapshot.paramMap.get('couponName') || this.activatedRoute?.snapshot?.parent?.paramMap?.get('couponName')) ?? '';
        const orgCouponName: string = this.getCouponFilterName() ?? '';
        const normalizedCouponName: string = this.getCouponName(couponName).toLowerCase();
        const availableCoupons = this.availableCouponsName.map((name) => name.toLowerCase().trim());
        const additionalMrkts = this.additionalMrkts.filter((mrkt: ICouponMarketSelector) => {
            const templateName = mrkt.templateMarketName.toLowerCase().trim();
            const combineCname = this.getCombineName(templateName, orgCouponName).toLowerCase();
            const combinealtCname = this.getCombineName(mrkt.alterName || '', orgCouponName).toLowerCase();
            return availableCoupons.includes(combineCname) || availableCoupons.includes(combinealtCname);
        });
        const isCpAvailableforDefaultMrkts = this.availableDateCoupons.some(
            (coup) => this.couponsListService.getCouponFilterName(coup.name) === orgCouponName,
        );
        let sourceMarkets: ICouponMarketSelector[] = this.isExcludedDate
            ? [...this.exclusiveMrkts, ...additionalMrkts]
            : this.isDefaultCoupon
              ? [...this.marketOptionsTemp, ...additionalMrkts]
              : this.marketOptionsTemp;
        if (!this.isExcludedDate && this.isDefaultCoupon) {
            sourceMarkets = isCpAvailableforDefaultMrkts ? sourceMarkets : additionalMrkts;
        }
        if (isAdditionalcId) {
            const matchingMarkets = sourceMarkets?.filter((market: ICouponMarketSelector) => {
                const marketName: string = market?.templateMarketName?.toLowerCase();
                const marketTitle: string = market?.title?.replace(/&/g, '').replace(/\s+/g, ' ').toLowerCase().trim();
                const marketalter: string = market?.alterName?.replace(/&/g, '').replace(/\s+/g, ' ').toLowerCase().trim() || '';
                return marketName === normalizedCouponName || marketTitle === normalizedCouponName || marketalter === normalizedCouponName;
            });
            const mergedMarkets: ICouponMarketSelector[] = [
                ...new Map([...matchingMarkets, ...sourceMarkets].map((market) => [market.templateMarketName, market])).values(),
            ];
            this.marketOptions = mergedMarkets;
        } else {
            this.marketOptions = sourceMarkets;
        }
    }
    /**
     * To get coupons based on filter
     * @returns - string
     */
    getCouponFilterName(): string {
        if (!this.couponFilter) {
            return '';
        }
        const isTodayCoupon = this.couponsListService.containsValue('marketSpecificInclusion', this.couponId);
        if (isTodayCoupon) {
            return DATED_COUPONS.TODAY;
        }
        if (this.couponsListService.containsValue(COUPONS.DATE_COUPONS as keyof ICouponsConfig, this.couponId)) {
            return this.couponsListService.getCouponFilterName(this.couponFilter);
        }
        if (!this.isDefaultCoupon) {
            return this.couponFilter;
        }
        return this.couponFilter.split(' ')[0];
    }
}
